import { AppContext } from 'next/app';

import { IAuthState } from './types';

export function initAuthBrowserApp(appContext: AppContext): IAuthState {
  const authState: IAuthState = {
    userProfile: null,
    anonymousId: null,
    refreshToken: null,
    accessToken: null,
  };

  // Access tokens are now in HTTP-only cookies, not accessible from client-side JS
  // The server-side auth state will be passed down via props
  // We can still check for userData in localStorage for backward compatibility during migration
  if (typeof window !== 'undefined') {
    try {
      // Check if localStorage is available and accessible
      if (!window.localStorage) {
        return authState;
      }
      const userDataStr = window.localStorage.getItem('userData');
      if (userDataStr) {
        try {
          authState.userProfile = JSON.parse(userDataStr);
        } catch (e) {
          console.error('Failed to parse userData from localStorage', e);
        }
      }
    } catch (e: any) {
      // Storage access may be blocked in some contexts (iframe, privacy settings, etc.)
      // Silently fail and rely on server-provided authState
      // Don't log SecurityError or storage-related errors to avoid console noise
      if (e?.name !== 'SecurityError' && !e?.message?.includes('storage')) {
        console.warn('localStorage access failed:', e);
      }
    }
  }

  const serverAuthState: IAuthState | undefined =
    appContext.router.components[appContext.router.route]?.props?.authState;

  if (serverAuthState) {
    Object.assign(authState, serverAuthState);
  }

  return authState;
}
